import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { url } from "../ConstUrl/Url";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { colors, fonts, size } from "../ColorFont/color";
import { Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";


const SponsoredHoursPopup = ({ open, onClose, user, plot, onUpdateUser }) => {
  const { t } = useTranslation("common");
  const [hours, setHours] = useState("");
  const [error, setError] = useState(null);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (hours > user.sponseredHours) {
      setError(t("sponsorErrorMoreHrs"));
      return;
    }

    // Ensure date and time are selected
    if (!date || !time) {
      setError(t("sponsorErrorDateTime"));
      return;
    }

    // Format the date and time
    const formattedDate = date.format("YYYY-MM-DD"); // Use dayjs or moment for formatting
    const formattedTime = time.format("HH:mm");

    // Update plot database with sponsored hours
    fetch(`${url}/api/assign-sponsor-hours`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: user._id,
        plotId: plot._id,
        sponsoredHours: hours,
        startDate: formattedDate,
        startTime: formattedTime,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Updated plot data:", data);
        // Update user state with new sponsored hours
        // Since we don't get the updated user back from this endpoint easily in the same format,
        // we'll fetch the latest user info to keep state in sync
        fetch(`${url}/api/users/get-user-by-id/${user._id}`)
          .then(res => res.json())
          .then(updatedUser => {
            onUpdateUser(updatedUser);
            onClose();
          });
      })
      .catch((error) => {
        console.error(error);
        onClose();
      });
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 4 }, // Adjust the value for desired roundness
      }}
    >
      <DialogTitle sx={{ padding: "14px", position: "relative" }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: fonts.poppins,
            fontSize: size.title,
            color: colors.primary_dark,
          }}
        >
          {t("sponsorHrsTitle")}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: "14px" }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t("hoursLabel")}
                type="number"
                value={hours}
                onChange={(event) => setHours(event.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={t("selectDateLabel")}
                  value={date}
                  onChange={(newDate) => setDate(newDate)}
                  PopperProps={{ disablePortal: true }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label={t("selectTimeLabel")}
                  value={time}
                  onChange={(newTime) => setTime(newTime)}
                  PopperProps={{ disablePortal: true }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </LocalizationProvider>
            </Grid>
            {error && (
              <Grid item xs={12}>
                <Typography color="error">{error}</Typography>
              </Grid>
            )}
          </Grid>
        </form>
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            fontFamily: fonts.poppins,
            backgroundImage: colors.button,
            padding: "8px 20px",
            borderRadius: 2,
            textTransform: "none",
          }}
        >
          {t("submitBtn")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SponsoredHoursPopup;
